
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6JR3B", function(module, exports) {
/**
 * @generated SignedSource<<2f4f826fbdca82535699cbbca06956d7>>
 * @relayHash 43d54ca288a673b02dda283e530d2603
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b90d6a1d6ed7a3cd6a9181b689700ee14f41bf49c21e3080a63fd98ed777861c
const $18fe6a1bc2131709$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CreateFromTemplateGetContentTypeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CreateFromTemplateGetContentTypeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "43d54ca288a673b02dda283e530d2603",
            "id": "b90d6a1d6ed7a3cd6a9181b689700ee14f41bf49c21e3080a63fd98ed777861c",
            "metadata": {},
            "name": "CreateFromTemplateGetContentTypeQuery",
            "operationKind": "query",
            "text": "query CreateFromTemplateGetContentTypeQuery($contentId:ID!){singleContent(id:$contentId){id,type}}"
        }
    };
}();
$18fe6a1bc2131709$var$node.hash = "74503a0f7f5b12c1389f8a393f9d456c";
var $18fe6a1bc2131709$export$2e2bcd8739ae039 = $18fe6a1bc2131709$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3u5lg = parcelRequire("3u5lg");


var $7ZB0A = parcelRequire("7ZB0A");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $eqNP8 = parcelRequire("eqNP8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $dhnmv = parcelRequire("dhnmv");


var $2YJkl = parcelRequire("2YJkl");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $9914C = parcelRequire("9914C");


var $10Oe6 = parcelRequire("10Oe6");


var $c0rhi = parcelRequire("c0rhi");

/**
 * @generated SignedSource<<57b2a49a1a235cdd9e751832521a6649>>
 * @relayHash c5eb0cfd9373eea79957d11b09418980
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d7a7335741148263b32cba82201410f4a6be5829e003845d67fea9f98d02335
const $bd66b9cbd254f119$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GetSpaceNameQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GetSpaceNameQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c5eb0cfd9373eea79957d11b09418980",
            "id": "9d7a7335741148263b32cba82201410f4a6be5829e003845d67fea9f98d02335",
            "metadata": {},
            "name": "GetSpaceNameQuery",
            "operationKind": "query",
            "text": "query GetSpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id,name}}"
        }
    };
}();
$bd66b9cbd254f119$var$node.hash = "af1524a43384ebea4777218a131343d7";
var $bd66b9cbd254f119$export$2e2bcd8739ae039 = $bd66b9cbd254f119$var$node;


const $ac5cbd4ec4be996f$export$39d77a27d933af98 = (0, $bd66b9cbd254f119$export$2e2bcd8739ae039);

/**
 * @generated SignedSource<<41d6a6968ed7a964cc1be30c228b133d>>
 * @relayHash 396d9a7d0dbd50c55cec1586a5cdc03d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6bdef190775fa903e65978f84114edd65263f11725156aa924a64550b3867c0e
const $e499bcd6af40a168$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "TemplateInfo",
            "kind": "LinkedField",
            "name": "templateInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "author"
                },
                {
                    "kind": "ScalarField",
                    "name": "blueprintModuleCompleteKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "categoryIds"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentBlueprintId"
                },
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasGlobalBlueprintContent"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasWizard"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconURL"
                },
                {
                    "kind": "ScalarField",
                    "name": "darkModeIconURL"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ScalarField",
                    "name": "isNew"
                },
                {
                    "kind": "ScalarField",
                    "name": "isPromoted"
                },
                {
                    "kind": "ScalarField",
                    "name": "itemModuleCompleteKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "link"
                },
                {
                    "concreteType": "LinksContextBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "context"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "recommendationRank"
                },
                {
                    "kind": "ScalarField",
                    "name": "spaceKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "styleClass"
                },
                {
                    "kind": "ScalarField",
                    "name": "templateId"
                },
                {
                    "kind": "ScalarField",
                    "name": "templateType"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GetTemplateInfoQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GetTemplateInfoQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "396d9a7d0dbd50c55cec1586a5cdc03d",
            "id": "6bdef190775fa903e65978f84114edd65263f11725156aa924a64550b3867c0e",
            "metadata": {},
            "name": "GetTemplateInfoQuery",
            "operationKind": "query",
            "text": "query GetTemplateInfoQuery($id:ID!){templateInfo(id:$id){author,blueprintModuleCompleteKey,categoryIds,contentBlueprintId,description,hasGlobalBlueprintContent,hasWizard,iconURL,darkModeIconURL,isFavourite,isNew,isPromoted,itemModuleCompleteKey,link,links{base,context},name,recommendationRank,spaceKey,styleClass,templateId,templateType}}"
        }
    };
}();
$e499bcd6af40a168$var$node.hash = "e768f9e88f51b2b2beb08ccad7f52efa";
var $e499bcd6af40a168$export$2e2bcd8739ae039 = $e499bcd6af40a168$var$node;


const $82ef4889545dda26$export$7e7d1d31b27ce20 = (0, $e499bcd6af40a168$export$2e2bcd8739ae039);


const $b9b360f49f6b8c27$var$_getSpaceNameQuery = async (variables)=>{
    return (await (0, $c0rhi.queryInterop)({
        query: (0, $ac5cbd4ec4be996f$export$39d77a27d933af98),
        variables: variables,
        __callerPackage__: "create-from-template"
    })).data;
};
const $b9b360f49f6b8c27$var$_getTemplateInfoQuery = async (variables)=>{
    return (await (0, $c0rhi.queryInterop)({
        query: (0, $82ef4889545dda26$export$7e7d1d31b27ce20),
        variables: variables,
        __callerPackage__: "create-from-template"
    })).data;
};
const $b9b360f49f6b8c27$export$16170ffac8499884 = async (spaceKey)=>{
    const spaceNameData = await $b9b360f49f6b8c27$var$_getSpaceNameQuery({
        spaceKey: spaceKey
    });
    return spaceNameData?.space?.name;
};
const $b9b360f49f6b8c27$export$1cdee53a58be8108 = async (id)=>{
    const templateData = await $b9b360f49f6b8c27$var$_getTemplateInfoQuery({
        id: id
    });
    return templateData?.templateInfo;
};















var $jn9ek = parcelRequire("jn9ek");

const $db5fd6a8f635d615$export$19da93f73216ea0b = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const startCreatePageExperience = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            attributes: {
                flow: 'createFromTemplateMacro',
                edition: edition
            }
        });
    }, [
        experienceTracker,
        edition
    ]);
    const succeedCreatePageExperience = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            attributes: {
                flow: 'createFromTemplateMacro'
            }
        });
    }, [
        experienceTracker
    ]);
    const stopCreatePageExperienceOnError = (0, $cozmU.useCallback)((error)=>{
        const cteTraceId = (0, $jn9ek.getTraceIdFromApolloError)(error);
        if (!cteTraceId) // When the error does not contain trace id, it's presumed that the network call failed due to network issue, thus aborting the experience
        experienceTracker.abort({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            reason: `${(0, $irVI7.CREATE_PAGE_EXPERIENCE)} aborted due to presumed client network failure`,
            attributes: {
                error: error?.message
            }
        });
        else experienceTracker.stopOnError({
            name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
            error: error,
            attributes: {
                cteTraceId: cteTraceId
            }
        });
    }, [
        experienceTracker
    ]);
    return {
        startCreatePageExperience: startCreatePageExperience,
        succeedCreatePageExperience: succeedCreatePageExperience,
        stopCreatePageExperienceOnError: stopCreatePageExperienceOnError
    };
};






var $9DHhW = parcelRequire("9DHhW");

const $29ff38e73df920b8$export$27deda0da73c7cc7 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const createCFTMacroAnalyticsEvent = (0, $cozmU.useCallback)(({ source: source = 'createFromTemplateMacro', type: type, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        createAnalyticsEvent({
            type: type,
            data: {
                source: source,
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return createCFTMacroAnalyticsEvent;
};



var $jMyy4 = parcelRequire("jMyy4");

const $92464a6d16d62abd$var$i18n = (0, $kSwu1.defineMessages)({
    createFromTemplateDefaultLabelText: {
        id: "create-from-template.inline-extension.create-from-template",
        defaultMessage: "Create from Template"
    },
    createFromTemplateError: {
        id: "create-from-template.inline-extension.create-from-template.error",
        defaultMessage: "You might not have permission to add content in the destination space. Check permissions, or edit the space key in the Create From Template macro."
    },
    unavailableTemplateError: {
        id: "create-from-template.inline-extension.create-from-template.unavailable-template.error",
        defaultMessage: "The original template has been deleted. Select a new template for the Create From Template macro."
    },
    notFoundError: {
        id: "create-from-template.inline-extension.create-from-template.not-found-graphql-error.error",
        defaultMessage: "Refresh the page to try again."
    },
    notFoundErrorTitle: {
        id: "create-from-template.inline-extension.create-from-template.not-found-graphql-error.error.title",
        defaultMessage: "We couldn\u2019t create new content for you"
    }
});
const $92464a6d16d62abd$var$CreateFromTemplateContainer = ({ macroDefaultProps: macroDefaultProps, flags: flags, isPreviewMode: isPreviewMode, ssrButtonLabel: ssrButtonLabel })=>{
    const { node: node, mode: mode, contentId: contentId, extensionKey: extensionKey } = macroDefaultProps;
    const [showLoading, setShowLoading] = (0, $cozmU.useState)(false);
    const [macroParams, setMacroParams] = (0, $cozmU.useState)({});
    const [currentTemplate, setCurrentTemplate] = (0, $cozmU.useState)();
    const [isPageType, setIsPageType] = (0, $cozmU.useState)(false);
    const { buttonLabel: userConfiguredButtonLabel, createButtonLabel: macroButtonLabel, contentBlueprintId: contentBlueprintId, templateId: templateId, spaceKey: spaceKey, blueprintModuleCompleteKey: blueprintModuleCompleteKey, title: pageTitle, pageType: pageType } = macroParams;
    const intl = (0, $kSwu1.useIntl)();
    const buttonLabel = ssrButtonLabel || userConfiguredButtonLabel || macroButtonLabel || intl.formatMessage($92464a6d16d62abd$var$i18n.createFromTemplateDefaultLabelText);
    const createFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const createCFTMacroAnalyticsEvent = (0, $29ff38e73df920b8$export$27deda0da73c7cc7)();
    const { startCreatePageExperience: startCreatePageExperience, stopCreatePageExperienceOnError: stopCreatePageExperienceOnError, succeedCreatePageExperience: succeedCreatePageExperience } = (0, $db5fd6a8f635d615$export$19da93f73216ea0b)();
    const effectiveSpaceKey = (0, $9wGTI.fg)('cft_macro_dont_force_spacekey') ? spaceKey || macroDefaultProps?.spaceKey : spaceKey;
    const isSameSpace = effectiveSpaceKey === macroDefaultProps?.spaceKey;
    const name = (0, $5kjCz.getExperienceName)(mode, node);
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const { userId: userId, isLicensed: isLicensed, timeZone: timeZone } = (0, $bQm3c.useSessionData)();
    const updateCustomTitle = async ()=>{
        if (pageTitle) {
            let title = pageTitle;
            if (title.includes('@spaceName')) {
                const spaceName = await (0, $b9b360f49f6b8c27$export$16170ffac8499884)(effectiveSpaceKey);
                title = title.replace(/@spaceName/g, `${spaceName}`);
            }
            if (title.includes('@currentDate')) {
                const currentDate = (0, $9914C.getUserTimezoneDate)({
                    userId: userId,
                    isLicensed: isLicensed,
                    timeZone: timeZone,
                    dateFormat: 'yyyy-MM-dd'
                });
                title = title.replace(/@currentDate/g, `${currentDate}`);
            }
            title = title.replace(/@spaceKey/g, `${effectiveSpaceKey}`);
            return title;
        }
        return '';
    };
    const { data: contentTypeQueryData, error: contentTypeQueryError, loading: contentTypeQueryLoading } = (0, $jMyy4.useQueryInterop)((0, $18fe6a1bc2131709$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "create-from-template"
    });
    (0, $cozmU.useEffect)(()=>{
        if (contentTypeQueryLoading) return;
        if (contentTypeQueryError) {
            if ((0, $1uFM6.isUnauthorizedError)(contentTypeQueryError) || (0, $f9jv7.isNotFoundError)(contentTypeQueryError)) (0, $7Sm4c.markErrorAsHandled)(contentTypeQueryError);
            else (0, $5ZqQS.getMonitoringClient)().submitError(contentTypeQueryError, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
        } else setIsPageType(contentTypeQueryData?.singleContent?.type === 'page');
    }, [
        contentTypeQueryData,
        contentTypeQueryError,
        contentTypeQueryLoading
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unwrapMacroParameters = ()=>{
            const macroParams = Object.keys(node.parameters.macroParams);
            const unwrappedParams = macroParams.reduce((acc, parameter)=>{
                if (!acc[parameter]) acc[parameter] = node.parameters.macroParams[parameter]?.value;
                return acc;
            }, {});
            setMacroParams(unwrappedParams);
        };
        unwrapMacroParameters();
    }, [
        node
    ]);
    const template = {
        contentBlueprintId: contentBlueprintId || null,
        templateId: templateId || null,
        blueprintModuleCompleteKey: blueprintModuleCompleteKey || null
    };
    const getSelectedTemplateInfo = async ()=>{
        const fetchedTemplate = await (0, $b9b360f49f6b8c27$export$1cdee53a58be8108)(templateId || contentBlueprintId || blueprintModuleCompleteKey);
        return fetchedTemplate ? {
            ...template,
            contentBlueprintId: fetchedTemplate.contentBlueprintId,
            hasWizard: fetchedTemplate.hasWizard,
            itemModuleCompleteKey: fetchedTemplate.itemModuleCompleteKey,
            iconURL: fetchedTemplate.iconURL,
            darkModeIconURL: fetchedTemplate.darkModeIconURL,
            blueprintModuleCompleteKey: blueprintModuleCompleteKey || fetchedTemplate?.blueprintModuleCompleteKey,
            name: fetchedTemplate.name
        } : null;
    };
    const handleMouseOver = async (showPreview, e)=>{
        const target = e?.currentTarget;
        e.persist();
        try {
            const selectedTemplate = await getSelectedTemplateInfo();
            setCurrentTemplate(selectedTemplate);
            experienceTracker.start({
                name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_PREVIEW,
                attributes: {
                    source: 'createFromTemplateMacro',
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(selectedTemplate)
                }
            });
            showPreview(selectedTemplate, target?.getBoundingClientRect(), 0);
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else handleTemplatePreviewError(error);
        }
    };
    const createContentFromTemplate = async ()=>{
        setShowLoading(true);
        startCreatePageExperience();
        try {
            const isTargetPageLive = pageType == 'live' && (0, $9wGTI.fg)('cft_macro_create_live_doc');
            createCFTMacroAnalyticsEvent({
                type: 'sendUIEvent',
                source: 'createFromTemplateMacro',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'useTemplate',
                attributes: {
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template),
                    isTargetPageLive: isTargetPageLive
                }
            });
            const title = await updateCustomTitle();
            const selectedTemplate = await getSelectedTemplateInfo();
            if (!selectedTemplate) {
                succeedCreatePageExperience();
                return await flags.showErrorFlag({
                    title: intl.formatMessage($92464a6d16d62abd$var$i18n.unavailableTemplateError)
                });
            }
            await createFromTemplate(selectedTemplate, effectiveSpaceKey, {
                title: title,
                parentPageId: isPageType && isSameSpace ? contentId : '',
                openContentInNewTab: true,
                subType: isTargetPageLive ? pageType : undefined
            });
        } catch (error) {
            if ((0, $f9jv7.isNotFoundError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                flags.showErrorFlag({
                    title: intl.formatMessage($92464a6d16d62abd$var$i18n.notFoundErrorTitle),
                    description: intl.formatMessage($92464a6d16d62abd$var$i18n.notFoundError)
                });
            } else if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                flags.showErrorFlag({
                    title: intl.formatMessage($92464a6d16d62abd$var$i18n.createFromTemplateError)
                });
            } else handleCreateFromTemplateError(error);
        } finally{
            setShowLoading(false);
        }
    };
    const handleCreateFromTemplateError = (error)=>{
        stopCreatePageExperienceOnError(error);
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        createCFTMacroAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'error',
            actionSubject: 'createFromTemplateMacro',
            actionSubjectId: 'contentCreateWithTemplateError',
            attributes: {
                errorMessage: error.message
            }
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        flags.showErrorFlag({
            title: intl.formatMessage($92464a6d16d62abd$var$i18n.createFromTemplateError)
        });
    };
    const handleTemplatePreviewError = (error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE),
            error: error,
            attributes: {
                source: 'createFromTemplateMacro'
            }
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        createCFTMacroAnalyticsEvent({
            type: 'sendTrackEvent',
            action: 'error',
            actionSubject: 'createFromTemplateMacro',
            actionSubjectId: 'templatePreview',
            attributes: {
                errorMessage: error.message
            }
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dhnmv.PopupPreview), {
        spaceKey: effectiveSpaceKey || macroDefaultProps?.spaceKey,
        templates: [
            currentTemplate
        ],
        hoverSource: "createFromTemplateMacro",
        hasDynamicPositioning: true,
        isEditorView: false
    }, ({ showPreview: showPreview, hidePreview: hidePreview })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            isDisabled: isPreviewMode,
            onClick: createContentFromTemplate,
            onMouseEnter: (e)=>handleMouseOver(showPreview, e),
            onFocus: (e)=>handleMouseOver(showPreview, e),
            onMouseLeave: hidePreview,
            onBlur: hidePreview
        }, buttonLabel)), showLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: name,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
const $92464a6d16d62abd$export$a6c71275c6598127 = /*#__PURE__*/ (0, $cozmU.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})((0, $7aRa9.withFlags)($92464a6d16d62abd$var$CreateFromTemplateContainer)), (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
module.exports["CreateFromTemplate"] = $92464a6d16d62abd$export$a6c71275c6598127;

});

parcelRegister("eqNP8", function(module, exports) {
/* FullPageLoadingScreen.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $94835ea6111c7010$var$zIndexBlanket = 500; // layers.blanket()
const $94835ea6111c7010$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _2IhTon715P _3OE6xY715P _1VJPcaiDnZ _42Yu6B6zpv",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_23rrnH4Jcb _42Yu6BN779 _0jFU0VN91d _39xV02N91d _1mT5xdy1CL _3OE6xYdnbC _2IhTondnbC _0KLXrulfZc _1YKVNs4qrS _3OZqoKe6K4",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$fe2b6579564feee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($94835ea6111c7010$export$7c6e2c02157bb7d2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "full-page-loading-screen",
        size: 26
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($94835ea6111c7010$export$5b927fc1ef8c468b, null));
module.exports["FullPageLoadingScreen"] = $94835ea6111c7010$export$fe2b6579564feee;

});

parcelRegister("dhnmv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9a42d0df36d411bd$export$65c74394172c28e5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2ysmR",
    name: "PopupPreview",
    loader: async ()=>(await (parcelRequire("3JgcJ"))).PopupPreview
});
module.exports["PopupPreview"] = $9a42d0df36d411bd$export$65c74394172c28e5;

});

parcelRegister("3JgcJ", function(module, exports) {

let $2b7224e9dd028ffd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b7224e9dd028ffd$var$load("7wlV6"),
    $2b7224e9dd028ffd$var$load("gEkwn"),
    $2b7224e9dd028ffd$var$load("cUdI6"),
    $2b7224e9dd028ffd$var$load("ei0GF"),
    $2b7224e9dd028ffd$var$load("90vep"),
    $2b7224e9dd028ffd$var$load("6wr18"),
    $2b7224e9dd028ffd$var$load("e1cuZ"),
    $2b7224e9dd028ffd$var$load("6kXh6"),
    $2b7224e9dd028ffd$var$load("jL43T"),
    $2b7224e9dd028ffd$var$load("52ZTT"),
    $2b7224e9dd028ffd$var$load("h1yOv"),
    $2b7224e9dd028ffd$var$load("aLwQm"),
    $2b7224e9dd028ffd$var$load("iBJWz"),
    $2b7224e9dd028ffd$var$load("kHXvF"),
    $2b7224e9dd028ffd$var$load("7gL7H"),
    $2b7224e9dd028ffd$var$load("ffEVr"),
    $2b7224e9dd028ffd$var$load("57PKM"),
    $2b7224e9dd028ffd$var$load("excC5"),
    $2b7224e9dd028ffd$var$load("bbLnX"),
    $2b7224e9dd028ffd$var$load("1UUnk"),
    $2b7224e9dd028ffd$var$load("bWc1Z"),
    $2b7224e9dd028ffd$var$load("jIi6N"),
    $2b7224e9dd028ffd$var$load("6Vp6A"),
    $2b7224e9dd028ffd$var$load("9L4dm"),
    $2b7224e9dd028ffd$var$load("kGmwI"),
    $2b7224e9dd028ffd$var$load("Wowvf"),
    $2b7224e9dd028ffd$var$load("2l8zo"),
    $2b7224e9dd028ffd$var$load("aAJyu"),
    $2b7224e9dd028ffd$var$load("f8Q8b"),
    $2b7224e9dd028ffd$var$load("7EorR"),
    $2b7224e9dd028ffd$var$load("hhss7"),
    $2b7224e9dd028ffd$var$load("hvHZS"),
    $2b7224e9dd028ffd$var$load("aAWLw"),
    $2b7224e9dd028ffd$var$load("bupWa")
]).then(()=>parcelRequire('bEmzp'));

});

parcelRegister("9914C", function(module, exports) {

var $f6RxU = parcelRequire("f6RxU");


var $7B2o3 = parcelRequire("7B2o3");

const $baec9e3e3fc5ba98$export$df19e8e99fa12ca2 = ({ userId: userId, isLicensed: isLicensed, timeZone: timeZone, dateFormat: dateFormat })=>{
    const isAnonymousUser = !userId || !isLicensed;
    const isLicensedWithTimezone = timeZone && !isAnonymousUser;
    const date = new Date();
    const currentTimezoneDate = isLicensedWithTimezone ? (0, $7B2o3.default)(date, timeZone, dateFormat) : (0, $f6RxU.default)(date, dateFormat);
    return currentTimezoneDate;
};
module.exports["getUserTimezoneDate"] = $baec9e3e3fc5ba98$export$df19e8e99fa12ca2;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("9o40q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("dw6y2", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jFumb = parcelRequire("jFumb");

const $5df2cb75c6140959$export$2b48bde4878a8630 = (metadata)=>{
    const data = 'content' in metadata ? metadata.content : metadata;
    const spaceKey = data?.space?.key;
    const subType = data?.subType;
    if (!spaceKey) return data._links.editui;
    if (subType === 'live') return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id
    });
    return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentId: data?.id,
        contentType: 'pages'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(data)
        }
    });
};
const $5df2cb75c6140959$export$4a4b0cb92802bec5 = (metadata)=>{
    const spaceAlias = metadata?.space?.alias;
    if (!spaceAlias) return metadata._links.editui;
    return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceAlias,
        contentId: metadata?.id,
        contentType: 'blog'
    }, {
        query: {
            draftShareId: (0, $jFumb.getDraftShareIdFromCreateContentMetadata)(metadata)
        }
    });
};
module.exports["createEditDraftPageUrl"] = $5df2cb75c6140959$export$2b48bde4878a8630;
module.exports["createEditDraftBlogUrl"] = $5df2cb75c6140959$export$4a4b0cb92802bec5;

});

parcelRegister("jFumb", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $517b1e1152d7e308$export$251fafe6ead5eb49 = (data)=>{
    const context = data?._links?.context || (0, $jlIaF.CONTEXT_PATH);
    const legacyUrl = data?._links?.editui || '';
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(context + legacyUrl);
    const id = legacyDraftRouteMatch?.query?.draftShareId;
    const draftShareId = Array.isArray(id) ? id[0] : id;
    return draftShareId || '';
};
module.exports["getDraftShareIdFromCreateContentMetadata"] = $517b1e1152d7e308$export$251fafe6ead5eb49;

});


//# sourceMappingURL=CreateFromTemplate.0f53727d.js.map
